var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "icons/ white / question") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons/-white-/-question",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "pause",
  transform: "translate(8.000000, 8.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C7.16,0 0,7.16 0,16 C0,24.84 7.16,32 16,32 C24.84,32 32,24.84 32,16 C32,7.16 24.84,0 16,0 Z M14.24,20 C14.24,21 13.44,21.76 12.48,21.76 C11.48,21.76 10.72,20.96 10.72,20 L10.72,12 C10.68,11.04 11.48,10.24 12.44,10.24 C13.44,10.24 14.24,11.04 14.24,12 L14.24,20 Z M21.32,20 C21.32,21 20.52,21.76 19.56,21.76 C18.56,21.76 17.8,20.96 17.8,20 L17.8,12 C17.76,11.04 18.56,10.24 19.52,10.24 C20.52,10.24 21.32,11.04 21.32,12 L21.32,20 Z",
  id: "Shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause.a3aca8d49b2c23e4a1d799cfc3cbb5c5.svg";